const SlideReducer = (state = { slide: 0 }, action) => {
  switch (action.type) {
    case "Slide":
      return { ...state, slide: action.payload };
    default:
      return state;
  }
};
export default SlideReducer;
